<div style="width: 100%; height: Calc(100vh - 110px);">
    <as-split direction="horizontal" (dragEnd)="dragEnd('pixel', $event)">
      <as-split-area [size]="68">
        <app-tunnel-sections-list></app-tunnel-sections-list>
      </as-split-area>
      <as-split-area [size]="32">
        <app-map target="sections" [rastersOnMap]="true"  [stressAreasOnMap]="true"  [dataPopup]="true" [lsService]="lsService" ></app-map>
      </as-split-area>
    </as-split>
  </div>
  